export default __webpack_public_path__ + "5fc92244995bc865ff1f599665e7a3cd.png";